import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import MobileMenu from "../components/MobileMenu";
import Overlay from "../components/Overlay";
import api from "../services/api";
import { useAuth } from "../contexts/AuthContext";
import Enamad from "../components/enamad";
import { Phone, Lock } from 'lucide-react';


export default function LOGIN() {
    const { isAuthenticated, setAccessToken } = useAuth();
    const navigate = useNavigate();

    const [phone, setPhone] = useState("");
    const [password, setPassword] = useState("");

    const [phoneError, setPhoneError] = useState("");
    const [passwordError, setPasswordError] = useState("");
    const [Error, setError] = useState("");

    const [menuOpen, setMenuOpen] = useState(false);

    useEffect(() => {
        if (isAuthenticated) {
            navigate('/dashboard')
        }
    }, [isAuthenticated])

    const validatePhone = (value: string) => {
        const regex = /^09[0-9]{9}$/;

        if (/[^0-9]/.test(value)) {
            setPhoneError("Only digits allowed");
            return false;
        }

        if (!regex.test(value)) {
            setPhoneError("Number must start with 09 and be 11 digits");
            return false;
        }

        setPhoneError("");
        return true;
    };

    const handlePhoneChange = (e: { target: { value: any; }; }) => {
        let val = e.target.value;
        setPhone(val);
        validatePhone(val);
    };

    const handlePasswordChange = (e: { target: { value: any; }; }) => {
        const val = e.target.value;
        setPassword(val);

        if (val.length < 6) {
            setPasswordError("Password must be at least 6 characters");
            return;
        }
        setPasswordError("");
    };

    const handleSubmit = async (e: { preventDefault: () => void; }) => {
        e.preventDefault();

        const okPhone = validatePhone(phone);
        const okPass = password.length >= 6;
        if (!okPhone || !okPass) return;

        try {
            const response = await api.post('/login', { phone, password });
            if (response.status === 200) {

                const access_token = response.data.token;

                setAccessToken(access_token);
                document.cookie = `gt=${access_token}; path=/; max-age=${60 * 60 * 24 * 30
                    }; SameSite=Lax; Secure`;

                navigate('/dashboard');
            }
            else setError('!!!مشکل در ورود');

        } catch (err) {
            setError('!!!مشکل در ورود');
        }
    };


    return (
        <div className="min-h-[100dvh] max-h-[100dvh] w-full bg-darkbg text-white overflow-x-hidden overflow-y-auto relative font-yekan">
            <Overlay active={menuOpen} close={() => setMenuOpen(false)} />
            <MobileMenu active={menuOpen} />

            <div className="fixed inset-0 z-0">
                <div
                    className="absolute inset-0 z-10"
                    style={{
                        backgroundImage: `linear-gradient(to bottom, 
                        #191919 0%, 
                        #191919 45%, 
                        #191919 60%, 
                        rgba(25, 25, 25, 0.9) 70%, 
                        rgba(25, 25, 25, 0.2) 100%
                    )`
                    }} />

                <div
                    className="md:w-1/2 ml-auto absolute inset-0 bg-cover bg-bottom md:bg-right-bottom bg-no-repeat"
                    style={{
                        backgroundImage: `url("../assets/img/bg.jpg")`,
                    }}
                />
            </div>


            <header dir='rtl' className={`md:absolute md:right-0 flex justify-between items-center py-4 px-6 relative z-60 
                           bg-gradient-to-t from-transparent to-[rgba(0,0,0,0.3)]
                           transition-all duration-500 ease-in-out`}>
                <button onClick={() => setMenuOpen(!menuOpen)}
                    className={`z-50 p-2 rounded-full backdrop-blur-sm 
                           flex justify-center items-center transition-all duration-500 ease-in-out
                           hover:bg-white/20 ${menuOpen ? 'rotate-90' : ''}`}>

                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 scale-150" fill="none" viewBox="0 0 24 24" stroke="#f4b400" strokeWidth="2">
                        {menuOpen ? (
                            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                        ) : (
                            <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16m-7 6h7" />
                        )}
                    </svg>
                </button>
            </header>

            <div className="relative z-20 h-[80vh] md:min-h-screen min-h-fit max-h-screen flex flex-col md:flex-row">

                <div className="hidden md:flex md:w-1/2 flex-col justify-center items-center bg-primary backdrop-blur-sm">
                    <img
                        className="w-52 mb-6"
                        src="../assets/img/desktop-logo.png"
                        alt="GRIT LOGO"
                    />
                    <p className="text-gray-900 text-2xl tracking-wider text-center px-8">
                        Discover the world.<br />Walk with us.
                    </p>
                    <Enamad />
                </div>

                <div className="flex-1 flex items-center justify-center px-5 pb-20 md:py-10 md:w-1/2">
                    <form
                        onSubmit={handleSubmit}
                        className="w-full max-w-[380px] rounded-3xl px-8 py-4 md:p-10 "
                    >


                        <div className="inset-0 flex justify-center items-center pointer-events-none h-[70px] aspect-[3/1] mx-auto">
                            <img src={"../assets/img/logo.png"} alt="Logo" className=" object-cover" />
                        </div>

                        <div className="flex justify-center aspect-[2/1]">
                            <img
                                className="w-full object-cover"
                                src="../assets/img/typo.png"
                                alt="GRIT LOGO"
                            />
                        </div>

                        <div className="space-y-5">
                            <div className="flex flex-col mb-4 w-full">
                                <div className="relative">
                                    <input
                                        type="tel"
                                        value={phone}
                                        onChange={handlePhoneChange}
                                        placeholder="09xxxxxxxxx"
                                        maxLength={11}
                                        className={`w-full px-4 py-3 rounded-full bg-transparent border text-right
                                        ${phoneError ? "border-red-500" : "border-gray-100"} text-white`}
                                    />
                                    <Phone
                                        className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 w-5 h-5"
                                        strokeWidth={2}
                                    />
                                </div>
                                <span className="text-red-400 text-xs mt-1">{phoneError}</span>
                            </div>

                            <div className="flex flex-col mb-4 w-full">
                                <div className="relative">
                                    <input
                                        type="password"
                                        value={password}
                                        onChange={handlePasswordChange}
                                        placeholder="رمز عبور"
                                        className={`w-full px-4 py-3 rounded-full bg-transparent border text-right
                                        ${passwordError ? "border-red-500" : "border-gray-100"} text-white`}
                                    />
                                    <Lock
                                        className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 w-5 h-5"
                                        strokeWidth={2}
                                    />
                                </div>
                                <span className="text-red-400 text-xs mt-1">{passwordError}</span>
                            </div>



                            <button
                                type="submit"
                                className="w-full mt-3 bg-primary hover:bg-yellow-500 active:scale-[0.985] transition
                                 text-black font-semibold py-3 rounded-full text-xl"

                            > ورود </button>
                            <div className="text-red-400 text-xs mt-1">{Error}</div>


                        </div>
                        <p onClick={() => navigate("/forgotPassword")}
                            className="mt-4 text-center text-gray-300 hover:text-gray-400 cursor-pointer transition max-w-fit mx-auto"
                        >
                            رمز عبور را فراموش کردی؟
                        </p>
                        <p onClick={() => navigate("/register")}
                            className="mt-4 text-center text-primary hover:text-yellow-300 cursor-pointer transition max-w-fit mx-auto"

                        >
                            ایجاد حساب کاربری
                        </p>
                    </form>
                </div>
            </div>
        </div>
    );
}